
import Vue from 'vue'
import { Portal } from 'portal-vue'
import Modal from './Modal.vue'
import copy from 'copy-to-clipboard'

export default Vue.extend({
  data() {
    return {
      shareUrl: this.$store.state.channel_url,
      showShareModal: false,
    }
  },
  methods: {
    copyToClipboard() {
      copy(this.shareUrl)
    },
    selectUrl() {
      const urlInputElement = this.$refs.urlInput as HTMLInputElement
      urlInputElement.select()
    },
  },
  components: {
    Portal,
    Modal,
  },
})
